












































import Vue from "vue";
import firebase from "firebase/app";
import helpers from "../helpers/helpers";
import { Blog, BlogCategories } from "@/models/blog";

export default Vue.extend({
  name: "EditBlog",

  props: {
    blog: Object as () => Blog,
    showModalValue: Boolean
  },
  data() {
    const self = this;
    return {
      fileName: "",
      editor: null,
      config: {
        key: "jUA1yB1C3E4E2F2E1pjB-22nfpdvh1D1uxueF5C4C3D3E2C2A3D6B3A1==",
        placeholderText: "Edit Your Content Here",
        charCounterCount: true,
        events: {
          initialized: function() {
            (self as any).editor = this;
            console.log("editorInstance", (self as any).editor);
            console.log("initialized");
          },
          "image.beforeUpload": async (images: any) => {
            const storage = firebase.storage();
            const storageRef = storage.ref();
            const imagesRef = storageRef.child(`images/${images[0].name}`);

            imagesRef.put(images[0]).then(snapshot => {
              snapshot.ref
                .getDownloadURL()
                .then(downloadURL => {
                  console.log("editor", (this as any).editor);
                  (this as any).editor.image.insert(
                    downloadURL,
                    null,
                    null,
                    (this as any).editor.image.get()
                  );
                  console.log("File available at", downloadURL);
                })
                .catch((error: Error) => {
                  console.log(error);
                });
            });
          },
          "file.beforeUpload": async (files: any) => {
            const storage = firebase.storage();
            const storageRef = storage.ref();
            const imagesRef = storageRef.child(`files/${files[0].name}`);
            const fileName = files[0].name;
            imagesRef.put(files[0]).then(snapshot => {
              snapshot.ref
                .getDownloadURL()
                .then(downloadURL => {
                  (this as any).editor.file.insert(downloadURL, fileName, {
                    link: downloadURL
                  });
                })
                .catch((error: Error) => {
                  console.log(error);
                });
            });
          }
        }
      },
      model: null,
      categoryRules: [(value: string) => !!value || "Required."],
      titleRules: [(value: string) => !!value || "Required."],
      authorRules: [(value: string) => !!value || "Required."],
      subtitleRules: [(value: string) => !!value || "Required."],
      valid: false,
      titleImageFile: this.blog.imageUrl ?? ({} as File),
      categoryOptions: Object.keys(BlogCategories).map(value => {
        return {
          text: helpers.camelToWords(value),
          value
        };
      }),
      liveOptions: [
        { value: false, text: "Not Live" },
        { value: true, text: "Live" }
      ],
      insertedImages: null
    };
  },
  methods: {
    validate(): boolean {
      return (this as any).$refs.form.validate();
    },
    passData() {
      if (!this.validate()) {
        return;
      }
      const updatedBlog: Blog = {
        ...this.blog
      };
      console.log("updatedBlog: ", updatedBlog);
      (this as any).showModal = false;
      this.$emit(
        "saveData",
        helpers.undefinedToNull(updatedBlog),
        this.titleImageFile
      );
    },
    deleteBlog() {
      if (confirm("Are you sure you want to delete the blog?")) {
        (this as any).showModal = false;
        this.$emit("deleteBlog", this.blog);
      }
    },
    addFileUploadButton() {
      (this.$refs.editor as any).DefineIcon("alert", { NAME: "info" });
    }
  },
  computed: {
    showModal: {
      get(): boolean {
        return (this as any).showModalValue;
      },
      set(value: boolean) {
        this.$emit("updateShowModalValue", value);
      }
    }
  }
});
